export class EventTypeDataVersion {
    constructor(eventTypeDataVersionId: number, version: string, createdUtc: Date, comment: string) {
        this.eventTypeDataVersionId = eventTypeDataVersionId;
        this.version = version;
        this.createdUtc = createdUtc;
        this.comment = comment;
    }
    eventTypeDataVersionId: number;
    version: string;
    createdUtc: Date;
    comment: string;
}
